import {
  SMS_DISCLAIMER_TEXT_QUERY,
  SMS_DISCLAIMER_TEXT_BY_EMAIL_QUERY
} from '@/shared-utils/queries/smsOptIn'
import useBootstrapData from '../useBootstrapData'

export type DisclaimerParams = {
  query: string
  clientGUID: string
  disclaimerParams: DisclaimerBaseParams
}

export type DisclaimerBaseParams = {
  emailAddress?: string
  disclaimerBaseParam: {
    placement: 'HOMEPAGE'
    appCode: 'MOBILEWEB' | 'DESKTOP'
    classification: 'PROMOTIONAL'
    PLFCode: 'PCLN'
  }
}

const baseParamsMobile = {
  disclaimerBaseParam: {
    placement: 'HOMEPAGE',
    appCode: 'MOBILEWEB',
    classification: 'PROMOTIONAL',
    PLFCode: 'PCLN'
  }
} as const

const baseParamsDesktop = {
  disclaimerBaseParam: {
    placement: 'HOMEPAGE',
    appCode: 'DESKTOP',
    classification: 'PROMOTIONAL',
    PLFCode: 'PCLN'
  }
} as const

export default function useSmsDisclaimerQueryArgs(): DisclaimerParams {
  const {
    customer: { emailAddress },
    signInStatus: { signedIn, passiveSignIn },
    isMobile,
    webstats: { clientGUID }
  } = useBootstrapData()

  const smsQueryArgs = isMobile ? baseParamsMobile : baseParamsDesktop

  const emailParams = {
    emailAddress,
    ...smsQueryArgs
  }
  return (signedIn || passiveSignIn) && emailAddress
    ? {
        disclaimerParams: emailParams,
        clientGUID,
        query: SMS_DISCLAIMER_TEXT_BY_EMAIL_QUERY
      }
    : {
        query: SMS_DISCLAIMER_TEXT_QUERY,
        clientGUID,
        disclaimerParams: smsQueryArgs
      }
}
